import {
  MaskableFieldHeader,
  useMaskableFieldExpanded,
} from "@/components/form-items/MaskableFieldHeader";
import type { MaskableFieldProps } from "@/components/form-items/MaskedFormFieldShell";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type MaskableFormFieldWrapperProps = {
  fieldName: string;
  label: ReactNode;
  children: ReactNode;
  className?: string;
} & MaskableFieldProps;

export function MaskableFormFieldWrapper({
  fieldName,
  label,
  children,
  nonMaskable,
  maskable,
  className,
}: MaskableFormFieldWrapperProps) {
  const { enabled: maskEnabled, showControl, minimized } =
    useMaskableFieldExpanded(fieldName, { nonMaskable, maskable });

  // Masked → hidden entirely (re-enable it from the field visibility menu).
  if (maskEnabled && !nonMaskable && minimized) {
    return null;
  }

  return (
    <div className={cn("w-full", className)}>
      {maskEnabled && !nonMaskable && (
        <MaskableFieldHeader
          fieldName={fieldName}
          maskable={maskable}
          className="mb-0 w-full"
          label={label}
        />
      )}
      <div className={cn(!showControl && maskEnabled && "hidden")}>
        {children}
      </div>
    </div>
  );
}
